window.addEventListener("load", function () {
  const links = document.querySelectorAll('#navigaion .nav-link');

  function setActiveLink(index) {
    links.forEach((item, itemIndex) => {
      const isActive = itemIndex === index;
      item.classList.toggle('is-active', isActive);
      if (isActive) item.setAttribute('aria-current', 'page');
      else item.removeAttribute('aria-current');
    });
  }

  const requestedFrame = Number(new URLSearchParams(window.location.search).get('frame'));
  setActiveLink(Number.isFinite(requestedFrame) && requestedFrame > 0 ? requestedFrame - 1 : 0);

  links.forEach((link, index) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      if (typeof window.goToMainFrame === 'function') {
        window.goToMainFrame(index + 1);
        return;
      }

      // Fallback if this navigation bundle is used without main.js.
      setActiveLink(index);
      window.dispatchEvent(new CustomEvent('main-frame-request', { detail: { index } }));
    });
  });

  window.addEventListener('main-frame-change', (event) => {
    const index = Number(event.detail && event.detail.index);
    if (Number.isInteger(index)) setActiveLink(index);
  });

  // --- Đổi ngôn ngữ ---
  const langSwitch = document.querySelector('#navigaion .lang-switch');
  if (!langSwitch) return;

  const langToggle = langSwitch.querySelector('.lang-toggle');
  const langOptions = langSwitch.querySelectorAll('.lang-option');

  function closeLangPanel() {
    langSwitch.classList.remove('is-open');
    langToggle.setAttribute('aria-expanded', 'false');
  }

  langToggle.addEventListener('click', (event) => {
    event.stopPropagation();
    const willOpen = !langSwitch.classList.contains('is-open');
    langSwitch.classList.toggle('is-open', willOpen);
    langToggle.setAttribute('aria-expanded', String(willOpen));
  });

  langOptions.forEach((option) => {
    option.addEventListener('click', (event) => {
      window.dispatchEvent(
        new CustomEvent('lang-change', { detail: { lang: option.dataset.lang } })
      );

      // Bản production trỏ href sang index-<lang>.html -> để browser điều hướng.
      // Chỉ chặn khi href là placeholder "#" (bản build dev chỉ có 1 trang).
      const href = option.getAttribute('href');
      if (href && href !== '#') return;

      event.preventDefault();
      langOptions.forEach((item) => {
        const isSelected = item === option;
        item.classList.toggle('is-active', isSelected);
        item.setAttribute('aria-selected', String(isSelected));
      });
      closeLangPanel();
    });
  });

  // Bấm ra ngoài hoặc Esc thì đóng droplist
  document.addEventListener('click', (event) => {
    if (!langSwitch.contains(event.target)) closeLangPanel();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeLangPanel();
  });
});
